import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "switch", "dot", "monthlyLabel", "annualLabel",
    "monthlyPrice", "monthlyNote", "annualPrice", "annualNote"
  ]

  toggle() {
    const isAnnual = this.switchTarget.getAttribute("aria-checked") === "true"
    const newState = !isAnnual

    this.switchTarget.setAttribute("aria-checked", String(newState))
    this.switchTarget.classList.toggle("bg-cyan-600", newState)
    this.switchTarget.classList.toggle("bg-gray-300", !newState)
    this.dotTarget.classList.toggle("translate-x-6", newState)
    this.dotTarget.classList.toggle("translate-x-1", !newState)

    this.monthlyLabelTarget.classList.toggle("text-gray-500", newState)
    this.monthlyLabelTarget.classList.toggle("font-medium", !newState)
    this.annualLabelTarget.classList.toggle("text-gray-500", !newState)
    this.annualLabelTarget.classList.toggle("font-medium", newState)

    if (this.hasMonthlyPriceTarget) {
      this.monthlyPriceTarget.classList.toggle("hidden", newState)
      this.monthlyNoteTarget.classList.toggle("hidden", newState)
      this.annualPriceTarget.classList.toggle("hidden", !newState)
      this.annualNoteTarget.classList.toggle("hidden", !newState)
    }
  }
}
